import React from 'react';
import styles from './styles.css';
import anchorStyles from '../Common/anchor.css';
import { useI18n, Link } from '../../utils/i18n';
import LogoWithTextEn from '../../public/logo/SVG/logo_text_en.svg';
import LogoWithTextAr from '../../public/logo/SVG/logo_text_ar.svg';
import SellDesktopIllustration from '../../public/illustrations/sell_desktop.svg';
import SellMobileIllustration from '../../public/illustrations/sell_mobile.svg';

export const TranslationsNeeded = 'components/SellPage/translations';

const Component: React.FC = () => {
  const { translations, language } = useI18n(TranslationsNeeded);
  return (
    <section className={styles.section}>
      <div className={styles.sectionContent}>
        <Link href="">
          <a className={styles.logoWrapper}>
            {
              language === 'en' ? <LogoWithTextEn /> : <LogoWithTextAr />
            }
          </a>
        </Link>
        <h1 className={styles.title}>
          {translations.title}
        </h1>
        <p className={styles.description}>
          {translations.description}
        </p>
        <div className={styles.goldenLine} />
        <div className={styles.cardsWrapper}>
          <div className={[
            styles.card,
            styles.cardShadow,
            styles.bigCard,
          ].join(' ')}
          >
            <div className={styles.bigCardInfo}>
              <div className={styles.illustrationsWrapper}>
                <div className={[
                  styles.sellDesktopIllustration,
                  styles.illustrationWrapper,
                ].join(' ')}
                >
                  <SellDesktopIllustration />
                </div>

                <div className={[
                  styles.sellMobileIllustration,
                  styles.illustrationWrapper,
                ].join(' ')}
                >
                  <SellMobileIllustration />
                </div>
              </div>

              <div className={styles.cardInfoWrapper}>
                <h2 className={styles.cardTitle}>
                  {translations.agent.title}
                </h2>

                <p className={styles.cardDescription}>
                  {translations.agent.description}
                </p>

                <h3 className={styles.cardSubtitle}>
                  {translations.agent.benefits.title}
                </h3>

                <ul className={styles.cardList}>
                  {translations.agent.benefits.description.map((description: string) => (
                    <li
                      key={description}
                      className={[
                        styles.cardBullet,
                        styles.cardText,
                      ].join(' ')}
                    >
                      {description}
                    </li>
                  ))}
                </ul>

                <h3 className={styles.cardSubtitle}>
                  {translations.agent.rate.title}
                </h3>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingBottom: '20px',
                }}
                >
                  <p className={styles.cardText}>
                    {translations.agent.rate.selling.title}
                    <strong>
                      {translations.agent.rate.selling.description}
                    </strong>
                  </p>

                  <p className={styles.cardText}>
                    {translations.agent.rate.renting.title}
                    <strong>
                      {translations.agent.rate.renting.description}
                    </strong>
                  </p>
                </div>

                <div className={styles.actionWrapper}>
                  <Link href="/sell/agent">
                    <a
                      className={[
                        anchorStyles.button,
                        anchorStyles.mediumButton,
                        anchorStyles.secondaryButton,
                      ].join(' ')}
                    >
                      {translations.agent.submitButton}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className={[
            styles.card,
            styles.cardShadow,
            styles.smallCard,
          ].join(' ')}
          >
            <h2 className={styles.cardTitle}>
              {translations.yourself.title}
            </h2>

            <p
              className={styles.cardDescription}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: translations.yourself.description }}
            />

            <div className={styles.actionWrapper}>
              <Link href="/sell/yourself">
                <a
                  className={[
                    anchorStyles.secondaryButton,
                    anchorStyles.mediumButton,
                  ].join(' ')}
                >
                  {translations.yourself.submitButton}
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const AllTranslationsNeeded: string[] = [
  TranslationsNeeded,
];

export default Component;
